/**
 * @file AgendaAppointment class is a wrapper of PlanItem from the backend api towards the Agenda.
 * @author Wim Haanstra
 */
import * as tslib_1 from "tslib";
import { PlanItemWrapper } from '../helpers/plan-item-wrapper';
import * as moment from 'moment';
/** AgendaAppointment class is a wrapper of the PlanItem entity containing an Appointment entity. */
var AgendaAppointment = /** @class */ (function (_super) {
    tslib_1.__extends(AgendaAppointment, _super);
    /**
     * Constructs a AgendaAppointment.
     * @param item The PlanItem being wrapped.
     */
    function AgendaAppointment(item) {
        return _super.call(this, item) || this;
    }
    Object.defineProperty(AgendaAppointment.prototype, "projectName", {
        /**
         * Gets a dummy project name.
         * @deprecated
         */
        get: function () {
            return 'Test project name';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgendaAppointment.prototype, "isAbcense", {
        get: function () {
            // Eerder hielde we rekening met Appointments die geen Absence als reden hadden.
            // Van deze Symagic Server mogelijkheid wordt geen gebruik gemaakt.
            // Appointments behoren nu functioneel altijd een Absence als reden te hebben.
            return true;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Gets the hours of leave in human readable format
     */
    AgendaAppointment.prototype.hoursOfLeave = function () {
        if (this.item && this.item.Item && this.item.Item['HoursOfLeave']) {
            return moment.duration(this.item.Item['HoursOfLeave']);
        }
        else {
            return moment.duration(0);
        }
    };
    Object.defineProperty(AgendaAppointment.prototype, "customerName", {
        /**
         * Gets a dummy customer name.
         * @deprecated
         */
        get: function () {
            return 'Test customer name';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Gets the appropriate collection of the given timeslot for this AgendaAppointment class.
     */
    AgendaAppointment.prototype.getCollectionOf = function (timeSlot) {
        // Eerder hielde we rekening met Appointments die geen Absence als reden hadden.
        // Van deze Symagic Server mogelijkheid wordt geen gebruik gemaakt.
        // Appointments behoren nu functioneel altijd een Absence als reden te hebben.
        return timeSlot.gridAbsences;
    };
    /**
     * Create a copy of this instance.
     */
    AgendaAppointment.prototype.makeCopy = function () {
        var copy = new AgendaAppointment(this.item);
        copy.covers = this.covers;
        copy.zIndex = this.zIndex;
        return copy;
    };
    /** The name of the concerns key property. */
    AgendaAppointment.concernsProperty = 'Concerns_Oid';
    return AgendaAppointment;
}(PlanItemWrapper));
export { AgendaAppointment };
